import theme from "../configs/theme";
import { isDeveloperPortalMode } from "./AppModeContext";

const FMS_CONFIG = {
  key: "fms",
  name: "Facility Management System",
  basePath: "/fms",
  defaultRoute: "/dashboard",
  config: {
    theme: theme,
    appName: "Facility Management System",
  },
  routes: () => import("../apps/fms/routes"),
  menuItems: () => import("../apps/fms/menu-items"),
};

const RMS_CONFIG = {
  key: "rms",
  name: "Recovery Management System",
  basePath: "/rms",
  defaultRoute: "/bookings",
  config: {
    theme: theme,
    appName: "Recovery Management System",
  },
  routes: () => import("../apps/rms/routes"),
  menuItems: () => import("../apps/rms/menu-items"),
};

const DEVELOPER_CONFIG = {
  key: "developer",
  name: "Developer Portal",
  basePath: "/developer",
  defaultRoute: "/dashboard",
  config: {
    theme: theme,
    appName: "Developer Portal",
  },
  routes: () => import("../apps/developer/routes"),
  menuItems: () => import("../apps/developer/menu-items"),
};

export const APP_REGISTRY = {
  fms: FMS_CONFIG,
  rms: RMS_CONFIG,
  developer: DEVELOPER_CONFIG,
};

export const getCurrentApp = () => {
  const pathname = window.location.pathname;
  const pathWithoutLang = pathname.replace(/^\/(en|ar)/, "");
  if (
    pathWithoutLang.startsWith("/developer") ||
    pathname.includes("/developer")
  ) {
    return APP_REGISTRY.developer;
  }
  if (pathWithoutLang.startsWith("/fms") || pathname.includes("/fms")) {
    return APP_REGISTRY.fms;
  }
  if (pathWithoutLang.startsWith("/rms") || pathname.includes("/rms")) {
    return APP_REGISTRY.rms;
  }

  /**
   * When the URL doesn't disambiguate the app (e.g. first hit on
   * `one.propforce.com/`), honor the portal mode: developer hosts default to
   * the developer app, everything else stays on FMS.
   */
  return isDeveloperPortalMode() ? APP_REGISTRY.developer : APP_REGISTRY.rms;
};

export const getAppByKey = (key) => APP_REGISTRY[key];

export const getAllApps = () => Object.values(APP_REGISTRY);

export const getAppFromPath = (path) => {
  const pathWithoutLang = path.replace(/^\/(en|ar)/, "");
  return getAllApps().find(
    (app) =>
      pathWithoutLang.startsWith(app.basePath) || path.includes(app.basePath),
  );
};
